/**
 * How the booking window has to be opened for the two-column layout to work: wide enough
 * for the rail beside the wizard, and without the body's own padding or reserved scrollbar
 * gutter — both would leave a white strip where the rail's grey should reach the edge.
 * The height is pinned on desktop: the steps differ a lot in length, and a window that
 * grows and shrinks with each one reads as flicker — the wizard column scrolls instead.
 */
export const bookingModalChrome = {
    size: 62,
    className: 'tw-max-w-[1040px] lg:tw-h-[min(780px,92vh)]',
    headerClassName: 'tw-mb-0',
    bodyClassName: 'tw-p-0',
    bodyStyle: { scrollbarGutter: 'auto' as const }
};
